import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  fetchTransitionListM,
  fetchWalletInfoBank,
  fetchWalletInfoCrypto,
} from "./FetchTransactions";
import { useEffect, useState } from "react";

// import TimeDifference from "../components/features/TimeDifference";
import { BankEl } from "../components/features/BankEl";
import LoadingElement from "../components/features/LoadingElement";
import { ClientName } from "./ClientName";

import notification from "../assets/images/notification.svg";
import notificationRead from "../assets/images/notification-read.svg";
import { checkMoney } from "../utils/configData";

const TransactionsManager = ({ userInfo, scheme }) => {
  const { t } = useTranslation();
  const [sort, setSort] = useState({ orderBy: "id", order: "up", offset: 0 });
  const [transactions, setTransactions] = useState([]);
  const [walletData, setWalletData] = useState({});
  const [page, setPage] = useState(0);

  const listTransactions = async (id, sort) => {
    fetchTransitionListM(id, sort).then(async (data) => {
      if (data) {
        const a = Number(data.count) / 8;
        setTransactions(data.transactions);
        if (a > 1) {
          setPage(Math.ceil(a));
        }

        const walletInfo = await Promise.all(
          data.transactions.map(async (transaction) => {
            const bankInfo = await fetchWalletInfoBank(transaction.buy_currency === "usdt" ? transaction.sell_wallet : transaction.buy_wallet);
            const cryptoInfo = await fetchWalletInfoCrypto(
              transaction.buy_currency !== "usdt" ? transaction.sell_wallet : transaction.buy_wallet
            );
            return { id: transaction.id, bankInfo, cryptoInfo };
          })
        );
        const newWalletData = walletInfo.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {});
        setWalletData(newWalletData);
      }
    });
  };

  function copyToClipboard(input, event) {
    // Перевіряємо, чи підтримує браузер Clipboard API
    if (!navigator.clipboard) {
      console.error('Clipboard API не підтримується у вашому браузері.');
      // Змінюємо клас елемента на помилковий
      if (event && event.target) {
        event.target.className = 'disabled';
      }
      return;
    }

    // Перетворюємо вхідні дані на рядок, якщо вони не є рядком
    const textToCopy = typeof input === 'string' ? input : input.toString();

    // Використовуємо API для запису в буфер обміну
    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        console.log('Текст успішно скопійований в буфер обміну.');
        // Змінюємо клас елемента на успішний
        if (event && event.target) {
          event.target.className = 'ri-check-line';
          setTimeout(() => {
            event.target.className = 'ri-clipboard-line';
          }, 700);
        }
      })
      .catch(err => {
        console.error('Сталася помилка при копіюванні в буфер обміну:', err);
        // Змінюємо клас елемента на помилковий
        if (event && event.target) {
          event.target.className = 'ri-close-line';
          setTimeout(() => {
            event.target.className = 'ri-clipboard-line';
          }, 700);
        }
      });
  }

  useEffect(() => {
    listTransactions(userInfo.id, sort);
  }, [userInfo, sort]);

  const sortTransactions = (by) => {
    if (by === sort.orderBy) {
      setSort((prev) => ({
        ...prev,
        order: sort.order === "up" ? "down" : "up",
        offset: 0,
      }));
    }
    if (by !== sort.orderBy) {
      setSort({ orderBy: by, order: "up", offset: 0 });
    }
  };

  const renderPageButtons = () => {
    const buttons = [];
    buttons.push(
      <button
        key={0}
        className={`setOffset ${sort.offset === 0 ? "active" : ""}`}
        onClick={() => setSort((prev) => ({ ...prev, offset: 0 }))}
      >
        <p style={{ width: "20px" }}>1</p>
      </button>
    );
    let start, end;
    if (sort.offset <= 2) {
      start = 1;
      end = Math.min(page - 2, 3);
    } else if (sort.offset >= page - 3) {
      start = Math.max(page - 4, 1);
      end = page - 2;
    } else {
      start = sort.offset - 1;
      end = sort.offset + 1;
    }
    if (start > 1) {
      buttons.push(<span key="start-ellipsis">...</span>);
    }
    for (let i = start; i <= end; i++) {
      buttons.push(
        <button
          key={i}
          className={`setOffset ${sort.offset === i ? "active" : ""}`}
          onClick={() => setSort((prev) => ({ ...prev, offset: i }))}
        >
          <p style={{ width: "20px" }}>{i + 1}</p>
        </button>
      );
    }
    if (end < page - 2) {
      buttons.push(<span key="end-ellipsis">...</span>);
    }
    buttons.push(
      <button
        key={page - 1}
        className={`setOffset ${sort.offset === page - 1 ? "active" : ""}`}
        onClick={() => setSort((prev) => ({ ...prev, offset: page - 1 }))}
      >
        <p style={{ width: "20px" }}>{page}</p>
      </button>
    );
    return buttons;
  };
  function convertTRCIdentifiers(input) {
    return input.replace(/trc(\d+)/gi, (match, number) => `(TRC-${number})`);
  }

  return (
    <div className="transactions-list">
      <h1>{t("My Clients")}</h1>

      <div className="transactions-list__table manager">
        <div className="transactions-list__table-wrapper">

          <h2
            onClick={() => sortTransactions(scheme[0])}
            className="start click"
          >
            {t("ID")} {sort.orderBy === scheme[0] ? <i
              style={{
                transform: sort.order === "up" ? "rotateX(0deg)" : "rotateX(180deg)"
              }}

              class="ri-arrow-down-s-line"
            ></i> : "-"}
          </h2>
          {transactions.map((transaction) => (
            <div
              className="transactions-list__table-item start"
              key={transaction.id}
              title={transaction.id}
            >
              {/* {!transaction.readed_m ? <div className="check-message"></div> : null} */}

              #{transaction.id.slice(0, 4)}... <i style={{ cursor: "pointer", fontSize: "14px" }} onClick={(event) => copyToClipboard(transaction.id, event)} className="ri-clipboard-line"></i>
            </div>
          ))}
        </div>




        <div className="transactions-list__table-wrapper">
          <h2
            onClick={() => sortTransactions(scheme[0])}
            className="click"
          >
            {t("Notif...")}

          </h2>
          {transactions.map((transaction, index) => {
            return (
              <div
                className="transactions-list__table-item"
                key={index}
              >
                {!transaction.readed_m ? <img style={{ borderRadius: "0px" }} src={notification} alt="" /> : <img style={{ borderRadius: "0px" }} src={notificationRead} alt="" />}

              </div>
            );
          })}
        </div>




        <div className="transactions-list__table-wrapper">
          <h2 className="click" onClick={() => sortTransactions(scheme[10])}>
            {t("Status")} {sort.orderBy === scheme[10] ? <i
              style={{
                transform: sort.order === "up" ? "rotateX(0deg)" : "rotateX(180deg)"
              }}
              class="ri-arrow-down-s-line"
            ></i> : "-"}
          </h2>
          {transactions.map((transaction) => {
            let textStatus = <LoadingElement mini={true} />;
            if (transaction.status === 0) {
              textStatus = "Matching";
            } else if (transaction.status === 1) {
              textStatus = "Pending";
            } else if (transaction.status === 2) {
              textStatus = "Reviewing";
            } else if (transaction.status === 3) {
              textStatus = "Fulfilled";
            } else if (transaction.status === 4) {
              textStatus = "Cancelled";
            }
            return (
              <div
                className="transactions-list__table-item"
                key={transaction.id}
              >
                <p className={`status ${textStatus}`}>{textStatus}</p>
              </div>
            );
          })}
        </div>

        <div className="transactions-list__table-wrapper">
          <h2 className="click" onClick={() => sortTransactions(scheme[8])}>
            {t("Pay with")} {sort.orderBy === scheme[8] ? <i
              style={{
                transform: sort.order === "up" ? "rotateX(0deg)" : "rotateX(180deg)"
              }}
              class="ri-arrow-down-s-line"
            ></i> : "-"}
          </h2>
          {transactions.map((transaction) => {
            const walletInfo = walletData[transaction.id];
            return (
              <div
                className="transactions-list__table-item wallet"
                key={transaction.id}
              >
                {walletInfo ? (
                  transaction.sell_currency === "usdt" ? (
                    <div>
                      <h3 style={{ textAlign: "left" }}>
                        {walletInfo.cryptoInfo
                          ? walletInfo.cryptoInfo.name
                          : t("This wallet has been deleted")}
                      </h3>
                      <p>
                        {walletInfo.cryptoInfo
                          ? `${walletInfo.cryptoInfo.curr.toUpperCase()} ${convertTRCIdentifiers(walletInfo.cryptoInfo.type.toUpperCase())} ${t(
                            "ending in"
                          )} ${walletInfo.cryptoInfo.num.slice(-4)}`
                          : null}
                      </p>
                    </div>
                  ) : (
                    <div>
                      <BankEl walletInfo={walletInfo} />
                      <p>
                        {walletInfo.bankInfo
                          ? `${walletInfo.bankInfo.curr.toUpperCase()} (${walletInfo.bankInfo.type.toUpperCase()}) ${t(
                            "ending in"
                          )} ${walletInfo.bankInfo.iban.slice(-4)}`
                          : null}
                      </p>
                    </div>
                  )
                ) : (
                  <LoadingElement mini={true} />
                )}
              </div>
            );
          })}
        </div>
        <div className="transactions-list__table-wrapper">
          <h2 className="click" onClick={() => sortTransactions(scheme[5])}>
            {t("Receive on")} {sort.orderBy === scheme[5] ? <i
              style={{
                transform: sort.order === "up" ? "rotateX(0deg)" : "rotateX(180deg)"
              }}
              class="ri-arrow-down-s-line"
            ></i> : "-"}
          </h2>
          {transactions.map((transaction) => {

            const walletInfo = walletData[transaction.id];
            return (
              <div
                className="transactions-list__table-item wallet"
                key={transaction.id}
              >
                {walletInfo ? (
                  transaction.sell_currency !== "usdt" ? (
                    <div>
                      <h3>
                        {walletInfo.cryptoInfo
                          ? walletInfo.cryptoInfo.name
                          : t("This wallet has been deleted")}
                      </h3>
                      <p>
                        {walletInfo.cryptoInfo
                          ? `${walletInfo.cryptoInfo.curr.toUpperCase()} ${convertTRCIdentifiers(walletInfo.cryptoInfo.type.toUpperCase())} ${t(
                            "ending in"
                          )} ${walletInfo.cryptoInfo.num.slice(-4)}`
                          : null}
                      </p>
                    </div>
                  ) : (
                    <div>
                      <BankEl walletInfo={walletInfo} />
                      <p>{walletInfo.bankInfo ? `${walletInfo.bankInfo.curr.toUpperCase()} (${walletInfo.bankInfo.type.toUpperCase()}) ${t(
                        "ending in"
                      )} ${walletInfo.bankInfo.iban.slice(-4)}` : null}</p>
                    </div>
                  )
                ) : (
                  <LoadingElement mini={true} />
                )}
              </div>
            );
          })}
        </div>

        <div className="transactions-list__table-wrapper">
          <h2 className="click" onClick={() => sortTransactions(scheme[7])}>
            {t("Give")} {sort.orderBy === scheme[7] ? <i
              style={{
                transform: sort.order === "up" ? "rotateX(0deg)" : "rotateX(180deg)"
              }}
              class="ri-arrow-down-s-line"
            ></i> : "-"}
          </h2>

          {transactions.map((transaction) => {

            const currencyImg = checkMoney(transaction.sell_currency).img;

            return (
              <div
                className="transactions-list__table-item"
                key={transaction.id}
              >
                <img src={currencyImg} alt="" />
                <p>{transaction.sell_amount}</p>
              </div>
            );
          })}

        </div>









        <div className="transactions-list__table-wrapper">
          <h2 className="click" >
            Fee
          </h2>

          {transactions.map((transaction) => {

            const currencyImg = checkMoney(transaction.sell_currency).img;

            return (
              <div
                className="transactions-list__table-item"
                key={transaction.id}
              >
                <img src={currencyImg} alt="" />
                <p>{transaction.fee}</p>
              </div>
            );
          })}

        </div>





        <div className="transactions-list__table-wrapper">
          <h2 className="click" >
            {t("Total")}
          </h2>

          {transactions.map((transaction) => {

            const currencyImg = checkMoney(transaction.sell_currency).img;

            return (
              <div
                className="transactions-list__table-item"
                key={transaction.id}
              >
                <img src={currencyImg} alt="" />
                <p>{(Number(transaction.sell_amount) + Number(transaction.fee)).toFixed(2)}</p>
              </div>
            );
          })}

        </div>






















        <div className="transactions-list__table-wrapper">
          <h2 className="click" onClick={() => sortTransactions(scheme[4])}>
            {t("Receive")}
          </h2>
          {transactions.map((transaction) => {
            const currencyImg = checkMoney(transaction.buy_currency).img;
            return (
              <div className="transactions-list__table-item" key={transaction.id}>

                <img src={currencyImg} alt="" />

                <p>{(Number(transaction.buy_amount))}</p>
              </div>
            )
          })}
        </div>



        <div className="transactions-list__table-wrapper">
          <h2 className="click" onClick={() => sortTransactions(scheme[11])}>
            {t("Date")} {sort.orderBy === scheme[11] ? <i
              style={{
                transform: sort.order === "up" ? "rotateX(0deg)" : "rotateX(180deg)"
              }}
              class="ri-arrow-down-s-line"
            ></i> : "-"}
          </h2>
          {transactions.map((transaction) => {

            function formatDate(dateString) {
              if (dateString !== null) {
                const cleanedDateString = dateString.split('.')[0];
                const date = new Date(cleanedDateString);
                const hours = date.getHours().toString().padStart(2, '0');
                const minutes = date.getMinutes().toString().padStart(2, '0');
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear();

                return `${hours}:${minutes}, ${day}.${month}.${year}`;
              } else {
                return "–"
              }
            }

            return (
              <div
                className="transactions-list__table-item wallet"
                key={transaction.id}
              >
                <div>
                  {transaction.opened ? <h3 style={{ textWrap: "nowrap" }}>
                    <span>open:</span>
                    {formatDate(transaction.opened)}
                  </h3> : null}
                  {transaction.closed ? <h3 style={{ textWrap: "nowrap" }}>
                    <span>closed:</span>
                    {formatDate(transaction.closed)}
                  </h3> : null}

                </div>
              </div>
            );
          })}
        </div>





        <div className="transactions-list__table-wrapper">
          <h2 className="end">{t("Manager")}</h2>
          {transactions.map((transaction) =>
            transaction.manager === null ||
              transaction.manager === userInfo.id ? (
              <div className="transactions-list__table-item end">
                <Link
                  className="default-button"
                  key={transaction.id}
                  to={`/chat/${transaction.chat}`}
                >
                  {transaction.manager === userInfo.id
                    ? t("Joined")
                    : t("Connect")}
                </Link>
              </div>
            ) : (
              <div
                className="transactions-list__table-item end"
                style={{
                  textDecoration: "none",
                  alignSelf: "center",
                  width: "auto",
                }}
              >

                <Link
                  className="no-link"
                  key={transaction.id}
                  to={`/chat/${transaction.chat}`}
                >
                  <ClientName managerId={transaction.manager} />

                  <i className="ri-user-2-line static"></i>
                  <i className="ri-arrow-right-line static"></i>
                </Link>
              </div>
            )
          )}
        </div>
        {page ? (
          <div className="footer-list m">
            <div className="footer-list-flex">
              {renderPageButtons()}
              <button
                className="setOffset"
                style={{ paddingLeft: "12px" }}
                onClick={() =>
                  setSort((prev) => ({
                    ...prev,
                    offset: Math.min(prev.offset + 1, page - 1),
                  }))
                }
              >
                Next <i className="ri-arrow-drop-right-line"></i>
              </button>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default TransactionsManager;
